import api from './apiService';

export const getPerfil = async () => {
    const response = await api.get('/accounts/perfil/');
    return response.data;
};

export const updatePerfil = async (profileData) => {
    const response = await api.patch('/accounts/perfil/', profileData);
    return response.data;
};